/**
 * @fileoverview gRPC-Web generated client stub for acompanha.account.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/account/v1/account.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_auth_v1_auth_pb = require('../../../acompanha/auth/v1/auth_pb.js')

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.account = {};
proto.acompanha.account.v1 = require('./account_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.account.v1.AccountServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.account.v1.AccountServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.account.v1.GetAccountRequest,
 *   !proto.acompanha.account.v1.GetAccountResponse>}
 */
const methodDescriptor_AccountService_GetAccount = new grpc.web.MethodDescriptor(
  '/acompanha.account.v1.AccountService/GetAccount',
  grpc.web.MethodType.UNARY,
  proto.acompanha.account.v1.GetAccountRequest,
  proto.acompanha.account.v1.GetAccountResponse,
  /**
   * @param {!proto.acompanha.account.v1.GetAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.account.v1.GetAccountResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.account.v1.GetAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.account.v1.GetAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.account.v1.GetAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.account.v1.AccountServiceClient.prototype.getAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/GetAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetAccount,
      callback);
};


/**
 * @param {!proto.acompanha.account.v1.GetAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.account.v1.GetAccountResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.account.v1.AccountServicePromiseClient.prototype.getAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/GetAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.account.v1.UpdateProfileRequest,
 *   !proto.acompanha.account.v1.UpdateProfileResponse>}
 */
const methodDescriptor_AccountService_UpdateProfile = new grpc.web.MethodDescriptor(
  '/acompanha.account.v1.AccountService/UpdateProfile',
  grpc.web.MethodType.UNARY,
  proto.acompanha.account.v1.UpdateProfileRequest,
  proto.acompanha.account.v1.UpdateProfileResponse,
  /**
   * @param {!proto.acompanha.account.v1.UpdateProfileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.account.v1.UpdateProfileResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.account.v1.UpdateProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.account.v1.UpdateProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.account.v1.UpdateProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.account.v1.AccountServiceClient.prototype.updateProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/UpdateProfile',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateProfile,
      callback);
};


/**
 * @param {!proto.acompanha.account.v1.UpdateProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.account.v1.UpdateProfileResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.account.v1.AccountServicePromiseClient.prototype.updateProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/UpdateProfile',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateProfile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.account.v1.UpdatePasswordRequest,
 *   !proto.acompanha.account.v1.UpdatePasswordResponse>}
 */
const methodDescriptor_AccountService_UpdatePassword = new grpc.web.MethodDescriptor(
  '/acompanha.account.v1.AccountService/UpdatePassword',
  grpc.web.MethodType.UNARY,
  proto.acompanha.account.v1.UpdatePasswordRequest,
  proto.acompanha.account.v1.UpdatePasswordResponse,
  /**
   * @param {!proto.acompanha.account.v1.UpdatePasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.account.v1.UpdatePasswordResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.account.v1.UpdatePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.account.v1.UpdatePasswordResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.account.v1.UpdatePasswordResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.account.v1.AccountServiceClient.prototype.updatePassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/UpdatePassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdatePassword,
      callback);
};


/**
 * @param {!proto.acompanha.account.v1.UpdatePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.account.v1.UpdatePasswordResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.account.v1.AccountServicePromiseClient.prototype.updatePassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/UpdatePassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdatePassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.account.v1.UpdateAvatarRequest,
 *   !proto.acompanha.account.v1.UpdateAvatarResponse>}
 */
const methodDescriptor_AccountService_UpdateAvatar = new grpc.web.MethodDescriptor(
  '/acompanha.account.v1.AccountService/UpdateAvatar',
  grpc.web.MethodType.UNARY,
  proto.acompanha.account.v1.UpdateAvatarRequest,
  proto.acompanha.account.v1.UpdateAvatarResponse,
  /**
   * @param {!proto.acompanha.account.v1.UpdateAvatarRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.account.v1.UpdateAvatarResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.account.v1.UpdateAvatarRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.account.v1.UpdateAvatarResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.account.v1.UpdateAvatarResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.account.v1.AccountServiceClient.prototype.updateAvatar =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/UpdateAvatar',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateAvatar,
      callback);
};


/**
 * @param {!proto.acompanha.account.v1.UpdateAvatarRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.account.v1.UpdateAvatarResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.account.v1.AccountServicePromiseClient.prototype.updateAvatar =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/UpdateAvatar',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateAvatar);
};


module.exports = proto.acompanha.account.v1;

